import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InvestorInvestManageSC from './investor-invest-manage.styled';
import InfoBanner from '../../../components/info-banner';
import ContentWrap from '../../../components/content-wrap';
import InvestorInvestManageBanner from '../../../components/investor-invest-manage-banner';
import InvestorInvestManageContent from '../../../components/investor-invest-manage-content';

const _InvestorInvestManage = ({ instruction }) => {
  return (
    <InvestorInvestManageSC>
      <InfoBanner isExtended>
        <InvestorInvestManageBanner instruction={instruction} />
      </InfoBanner>
      <ContentWrap>
        <InvestorInvestManageContent instruction={instruction} />
      </ContentWrap>
    </InvestorInvestManageSC>
  );
};

const mapStateToProps = (state) => {
  return {
    instruction: state.instruction,
  };
};

const InvestorInvestManage = withRouter(connect(mapStateToProps)(_InvestorInvestManage));

export default InvestorInvestManage;
